  import React, { useEffect, useState, useRef } from 'react';
  import moment from 'moment';
  import LineChart from './Graph/LineChartBlood';
  import * as firebase from 'firebase';
  import styles from '../../styles/ShareGraphs.module.css';
    
  const Bloodpreasure = (props) => {

    // arrey with object with {id, date, highP, lowP, pulz}
    const [allPreasure, setAllPreasure] = useState(); 
    
    // getting arrays in order for graph
    const [highPreasure, setHighPreasure] = useState(); // setting array of high preasure
    const [lowPreasure, setLowPreasure] = useState(); // setting array of low preasure
    const [pulz, setPulz] = useState(); // setting array of pulz
    const [dateArray, setDateArray] = useState(); // setting array of dates

    let userId = props.data // getting UID

    // *
    // best way to check for mounted component !!
    const isCurrent = useRef(true);

    useEffect(() => {
      return () => {
        isCurrent.current = false;
      }
    }, [])
    // * for checking mounted components
    // *
    // then use 
    // if (isCurrent.current) { setState(XXYY) }  !!

    const getDataFirebase = (userId) => {
      //let array: any;
      let data;
      console.log("checking how many times it renders !!")
      // getting data from location for WEIGHT
      let getData = firebase.database().ref('/users/' + userId + '/bloodpreasure');
      getData.on('value', function(snapshot) {
        //console.log(snapshot.val());
        data = snapshot.val();
        if (data !== null) {
          // getting data to correct form ID:, DATE:, WEIGHT:
          const allPreasureArray = Object.keys(data).map( key => {
            return  { 
              id: key, 
              date: data[key].date, 
              highP: data[key].highP,
              lowP: data[key].lowP,
              pulz: data[key].pulz 
            };
          })
          // set in reverse order so the last input is 1 in line
          // checking for componenet is mounted !!
          if (isCurrent.current) { setAllPreasure(allPreasureArray.reverse()) }
          
          //const dateArray =
          let testDate = [];
          allPreasureArray.map( each => {
            return testDate.push(each.date)
          })
          console.log("datearray?: " + testDate)
          if (isCurrent.current) { setDateArray(testDate.reverse()) }
          
          //const highP = 
          let testHighP = [];
          allPreasureArray.map( each => {
            return testHighP.push(each.highP)
          })
          console.log("highParray?: " + testHighP)
          if (isCurrent.current) { setHighPreasure(testHighP.reverse()) }
          
          //const lowP =
          let testLowP = []; 
          allPreasureArray.map( each => {
            return testLowP.push(each.lowP)
          })
          console.log("lowParray?: " + testLowP)
          if (isCurrent.current) { setLowPreasure(testLowP.reverse()) }
          
          //const pulz = 
          let testPulz = [];
          allPreasureArray.map( each => {
            return testPulz.push(each.pulz)
          })
          console.log("pulzarray?: " + testPulz)
          if (isCurrent.current) { setPulz(testPulz.reverse()) }
        }
      })
    }

    useEffect(() => {
      getDataFirebase(userId)  //user.uid);
    }, [userId])

    const handleAll = () => {
      let testAllDate = [];
      let testAllHighPreasure = [];
      let thisAllArray = [];
      let testAllLowPreasure = [];
      let testAllPulz = [];

      // date, highP, lowP, pulz
      allPreasure.forEach( (preasure) => {
          thisAllArray.push(preasure);
          testAllDate.push(preasure.date);
          testAllHighPreasure.push(preasure.highP);
          testAllLowPreasure.push(preasure.lowP);
          testAllPulz.push(preasure.pulz);
      })
      if (isCurrent.current) { setDateArray(testAllDate.reverse()) }
      if (isCurrent.current) { setHighPreasure(testAllHighPreasure.reverse()) }
      if (isCurrent.current) { setLowPreasure(testAllLowPreasure.reverse()) }
      if (isCurrent.current) { setPulz(testAllPulz.reverse()) }
      
      console.log("rendering all data")
    }
    const handleMonth = () => {
      let testMonthDate = [];
      let testMonthHighPreasure = [];
      let testMonthLowPreasure = [];
      let testMonthPulz = [];
      let thisMonthArray = [];
      let thisMonthStart = moment().subtract(1, 'month').format("YYYY/MM/DD");
      
      allPreasure.forEach( (preasure) => {
        if (moment(preasure.date).isSameOrAfter(thisMonthStart)) {
          thisMonthArray.push(preasure);
          testMonthDate.push(preasure.date);
          testMonthHighPreasure.push(preasure.highP);
          testMonthLowPreasure.push(preasure.lowP);
          testMonthPulz.push(preasure.pulz);
        }
      })
      if (isCurrent.current) { setDateArray(testMonthDate.reverse()) }
      if (isCurrent.current) { setHighPreasure(testMonthHighPreasure.reverse()) }
      if (isCurrent.current) { setLowPreasure(testMonthLowPreasure.reverse()) }
      if (isCurrent.current) { setPulz(testMonthPulz.reverse()) }
        
      console.log("Month");
    }
    const handleWeek = () => {
      let testWeekDate = [];
      let testWeekHighPreasure = [];
      let testWeekLowPreasure = [];
      let testWeekPulz = [];
      let thisWeekArray = [];
      let thisWeekStart = moment().subtract(1, 'week').format("YYYY/MM/DD");
      
      allPreasure.forEach( (preasure) => {
        if (moment(preasure.date).isSameOrAfter(thisWeekStart)) {
          thisWeekArray.push(preasure);
          testWeekDate.push(preasure.date);
          testWeekHighPreasure.push(preasure.highP);
          testWeekLowPreasure.push(preasure.lowP);
          testWeekPulz.push(preasure.pulz);
        }
      })
      if (isCurrent.current) { setDateArray(testWeekDate.reverse()) }
      if (isCurrent.current) { setHighPreasure(testWeekHighPreasure.reverse()) }
      if (isCurrent.current) { setLowPreasure(testWeekLowPreasure.reverse()) }
      if (isCurrent.current) { setPulz(testWeekPulz.reverse()) }
        
      console.log("week")
    }
    
    return (
      <div className={styles.Desktop} >
        <div className={styles.MainTitle}>
            <p>Graf: Pritisk, Pulz</p>
        </div>
        <div className={styles.MainInfo}>
          <div className={styles.BeforeChart}>
            <LineChart 
              dateArray={dateArray} 
              highP={highPreasure}
              lowP={lowPreasure}
              pulz={pulz}/>
          </div>
            {/*   TESTING 3 buttons for WEEK, MONTH, ALL*/}
            <div className={styles.InChart}>
              <div
                onClick={() => handleWeek()} 
                className={styles.InChartButton}>teden</div>
              <div
                onClick={() => handleMonth()}
                className={styles.InChartButton}>mesec</div>
              <div
                onClick={() => handleAll()}
                className={styles.InChartButton}>skupaj</div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Bloodpreasure;